import { NavLink } from 'react-router-dom';
import { X } from 'lucide-react';
import { useIsAdmin, useUIStore } from '../../store';
import { cn } from '../../utils/helpers';
import { t } from '../../i18n';
import { BrandMark } from './Brand';
import { ADMIN_NAVIGATION, NAVIGATION, type NavItem } from './navigation';

export function Sidebar() {
  const isAdmin = useIsAdmin();
  const { sidebarOpen, setSidebarOpen } = useUIStore();

  const link = (item: NavItem) => (
    <NavLink
      key={item.href}
      to={item.href}
      end={item.end}
      onClick={() => setSidebarOpen(false)}
      className={({ isActive }) =>
        cn(
          'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
          isActive ? 'bg-primary-50 text-primary-700' : 'text-secondary-600 hover:bg-secondary-100 hover:text-secondary-900',
        )
      }
    >
      <item.icon className="h-5 w-5 shrink-0" aria-hidden="true" />
      <span className="flex-1">{item.name}</span>
      {item.upcoming && (
        <span className="rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-amber-800">{t('Čoskoro')}</span>
      )}
    </NavLink>
  );

  return (
    <>
      {sidebarOpen && (
        <div className="fixed inset-0 z-30 bg-secondary-900/40 lg:hidden" onClick={() => setSidebarOpen(false)} aria-hidden="true" />
      )}
      <aside
        className={cn(
          'fixed inset-y-0 left-0 z-40 flex w-64 flex-col border-r border-secondary-200 bg-white transition-transform duration-200 lg:translate-x-0',
          sidebarOpen ? 'translate-x-0' : '-translate-x-full',
        )}
      >
        <div className="flex h-16 items-center justify-between gap-2 border-b border-secondary-200 px-4">
          <BrandMark />
          <button className="icon-btn lg:hidden" onClick={() => setSidebarOpen(false)} aria-label={t('Zavrieť menu')}>
            <X className="h-5 w-5" />
          </button>
        </div>
        <nav className="flex-1 space-y-1 overflow-y-auto p-3" aria-label={t('Hlavná navigácia')}>
          {NAVIGATION().map(link)}
          {isAdmin && (
            <>
              <p className="px-3 pb-1 pt-5 text-xs font-semibold uppercase tracking-wider text-secondary-400">{t('Administrácia')}</p>
              {ADMIN_NAVIGATION().map(link)}
            </>
          )}
        </nav>
      </aside>
    </>
  );
}
